let API_BASE = "/api";

export class SkillConstants {
  public static SKILLS_FETCH_ALL_API = API_BASE + "/skill";
  public static API_SKILLS_ADD = API_BASE + "/skill:add";
  public static API_SKILLS_UPDATE = API_BASE + "/skill/{skillId}";
}
